































import { Component, Vue } from 'vue-property-decorator'
import { TriggeredReferral } from '@/api/model/triggered-referral'
import { v4 as uuid } from 'uuid'

@Component
export default class TriggeredReferralCreate extends Vue {
    triggeredReferral: TriggeredReferral = null
    loading: boolean = false

    async mounted() {
        this.loading = true
        this.createNewTriggeredReferral()
        this.loading = false
    }

    createNewTriggeredReferral() {
        this.triggeredReferral = new TriggeredReferral(
            uuid(),
            this.$currentCompany,
            null,
            null,
            [],
            null,
            [],
            null,
            [],
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            '',
            7,
            true,
            new Date(),
            new Date(),
        )
    }

    async goBackToListener(): Promise<void> {
        await this.$router.push({
            name: 'company_settings_virtual_colleague_triggered_referral',
        })
    }
}
